import { Fade } from "./Fade";
export { Fade as default, Fade };
//# sourceMappingURL=index.js.map